import { useApi } from "../../../swr/useApi";
import { api } from "../../api_client";

export interface ProductWarrantyProvider {
  id: number;
  name: string;
  active: boolean;
}

/**
 * The generated API client doesn't expose this endpoint until
 * `npm run generate:api` runs after the BE module ships. Use a direct axios
 * call so the admin catalog + create-product flow work in the meantime.
 */
export function useProductWarrantyProviders() {
  // useApi expects an axios-style service that returns AxiosResponse — it
  // unwraps `.data` internally. Returning `api.get(...)` directly is the
  // shape it wants; previously we awaited+unwrapped here, which made useApi
  // try to read `.data.data` and produced an undefined list.
  return useApi<ProductWarrantyProvider[]>("product-warranty-providers", () =>
    api.get<ProductWarrantyProvider[]>("/api/v1/product-warranty-providers"),
  );
}
